import { render, staticRenderFns } from "./OptionData.vue?vue&type=template&id=245d00cd&scoped=true&"
import script from "./OptionData.vue?vue&type=script&lang=js&"
export * from "./OptionData.vue?vue&type=script&lang=js&"
import style0 from "./OptionData.vue?vue&type=style&index=0&id=245d00cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d00cd",
  null
  
)

export default component.exports